import { createSlice } from "@reduxjs/toolkit"

type VideoState = {
    dismissedVideoFlightIds: string[]
    flightPathEnabledByFlightId: Record<string, boolean>
    droneIconEnabledByFlightId: Record<string, boolean>
    crosshairEnabledByFlightId: Record<string, boolean>
    frameEnabledByFlightId: Record<string, boolean>
    activeShareModalFlightId: string | undefined
}
const initialState: VideoState = {
    dismissedVideoFlightIds: [],
    flightPathEnabledByFlightId: {},
    droneIconEnabledByFlightId: {},
    crosshairEnabledByFlightId: {},
    frameEnabledByFlightId: {},
    activeShareModalFlightId: undefined,
}

export const videoSliceName = "video" as const

export const {
    reducer: videoSliceReducer,
    actions: {
        markVideoFlightUndismissed,
        markVideoFlightDismissed,
        markAllVideoFlightsDismissed,
        enableFlightPath,
        disableFlightPath,
        toggleFlightPath,
        enableDroneIcon,
        disableDroneIcon,
        toggleDroneIcon,
        enableCrosshair,
        disableCrosshair,
        toggleCrosshair,
        enableFrame,
        disableFrame,
        toggleFrame,
        setActiveShareModalFlightId,
    },
} = createSlice({
    name: videoSliceName,
    initialState,
    reducers: {
        markVideoFlightUndismissed: (state, action: { payload: { flightId: string } }) => {
            state.dismissedVideoFlightIds = state.dismissedVideoFlightIds.filter(
                (id) => id !== action.payload.flightId
            )
        },
        markVideoFlightDismissed: (state, action: { payload: { flightId: string } }) => {
            const { flightId } = action.payload
            if (!state.dismissedVideoFlightIds.includes(flightId)) {
                state.dismissedVideoFlightIds.push(flightId)
            }
        },
        markAllVideoFlightsDismissed: (state, action: { payload: { flightIds: string[] } }) => {
            action.payload.flightIds.forEach((flightId) => {
                if (!state.dismissedVideoFlightIds.includes(flightId)) {
                    state.dismissedVideoFlightIds.push(flightId)
                }
            })
        },
        enableFlightPath: (state, action: { payload: { flightId: string } }) => {
            state.flightPathEnabledByFlightId[action.payload.flightId] = true
        },
        disableFlightPath: (state, action: { payload: { flightId: string } }) => {
            state.flightPathEnabledByFlightId[action.payload.flightId] = false
        },
        toggleFlightPath: (state, action: { payload: { flightId: string } }) => {
            const { flightId } = action.payload
            if (!Object.keys(state.flightPathEnabledByFlightId).includes(flightId)) {
                state.flightPathEnabledByFlightId[flightId] = true
            }
            state.flightPathEnabledByFlightId[flightId] =
                !state.flightPathEnabledByFlightId[flightId]
        },
        enableDroneIcon: (state, action: { payload: { flightId: string } }) => {
            state.droneIconEnabledByFlightId[action.payload.flightId] = true
        },
        disableDroneIcon: (state, action: { payload: { flightId: string } }) => {
            state.droneIconEnabledByFlightId[action.payload.flightId] = false
        },
        toggleDroneIcon: (state, action: { payload: { flightId: string } }) => {
            const { flightId } = action.payload
            if (!Object.keys(state.droneIconEnabledByFlightId).includes(flightId)) {
                state.droneIconEnabledByFlightId[flightId] = true
            }
            state.droneIconEnabledByFlightId[flightId] = !state.droneIconEnabledByFlightId[flightId]
        },
        enableCrosshair: (state, action: { payload: { flightId: string } }) => {
            state.crosshairEnabledByFlightId[action.payload.flightId] = true
        },
        disableCrosshair: (state, action: { payload: { flightId: string } }) => {
            state.crosshairEnabledByFlightId[action.payload.flightId] = false
        },
        toggleCrosshair: (state, action: { payload: { flightId: string } }) => {
            const { flightId } = action.payload
            if (!Object.keys(state.crosshairEnabledByFlightId).includes(flightId)) {
                state.crosshairEnabledByFlightId[flightId] = true
            }
            state.crosshairEnabledByFlightId[flightId] = !state.crosshairEnabledByFlightId[flightId]
        },
        enableFrame: (state, action: { payload: { flightId: string } }) => {
            state.frameEnabledByFlightId[action.payload.flightId] = true
        },
        disableFrame: (state, action: { payload: { flightId: string } }) => {
            state.frameEnabledByFlightId[action.payload.flightId] = false
        },
        toggleFrame: (state, action: { payload: { flightId: string } }) => {
            const { flightId } = action.payload
            if (!Object.keys(state.frameEnabledByFlightId).includes(flightId)) {
                state.frameEnabledByFlightId[flightId] = true
            }
            state.frameEnabledByFlightId[flightId] = !state.frameEnabledByFlightId[flightId]
        },
        setActiveShareModalFlightId: (
            state,
            action: { payload: { flightId: string | undefined } }
        ) => {
            state.activeShareModalFlightId = action.payload.flightId
        },
    },
})
